(function() {
  'use strict';

  angular.module('cfn').directive('dTabWithCount', function() {
    return {
      transclude: true,
      restrict: 'E',
      require: '^dTabContainer',
      scope: {
        // inherited from tab
        index: '@',
        clickAction: '&?',
        cls: '@',

        // additional values
        countShow: '=?',
        countTotal: '=?',
        countUnread: '=?',
        title: '@'
      },
      templateUrl: require('./d-tab-with-count.html')
    };
  });
})();
